"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OurStory = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _navigation = require("../../../context/navigation");
var _constants = require("../constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const OurStory = () => {
  const {
    aboutItems: items
  } = (0, _navigation.useBurgerMenu)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    children: items.map(({
      linkType,
      title,
      url
    }) => {
      if (linkType === 'SupportCenter') {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.OurStorySupportLink, {
          href: url ?? undefined,
          "data-testid": getTestId(_constants.OUR_STORY_SUPPORT_LINK),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.BubbleHelp, {
            fontSize: "inherit"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.OurStorySupportTitle, {
            children: title
          })]
        }, title);
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.OurStoryStoryLink, {
        href: url ?? undefined,
        "data-testid": getTestId(_constants.OUR_STORY_LINK),
        children: title
      }, title);
    })
  });
};
exports.OurStory = OurStory;
